<template>
<div>
    <div :class="$style.main">
    <!--{{selected_reports}}-->
        <div :class="$style.grant_access_container">
        <fieldset>
                    <legend :class="$style.section_label">
                        {{ 'reports' | str }} {{selected_reports.length}}/{{list_reports.length}}
                        <div :class="$style.selectAll"> <label>{{'select_all' | str}}: <input type='checkbox' v-model="checked" @change="toggle_check_all"></label></div>
                    </legend>
                    <div :class="$style.formItem" >
                <div :class="$style.main_label">{{'retention' | str}}:</div> 
                &nbsp;
                <input type="number" v-model.number="newRetentionPolicy">
                &nbsp;      
                <div :class="$style.main_label">{{'days' | str}}</div> 
                <br>
                <br>
                <input type="text" v-model="report_search" :placeholder="label('search_reports')">
                <br>
                </div>
                    <div :class="$style.checkbox_container">
                    
                    <table>
                        <thead>
                        <tr>
                        <th style="text-align: left; font-size: 0.8em; vertical-align: middle;">Report</th>
                        <th style="text-align: center; font-size: 0.8em; vertical-align: middle;">Retention</th>
                        </tr>
                        </thead>
                        
                    
                        <tr :key="'report_'+record.id" v-for="record in filtered_reports">
                            <td style="width:85%">                           
                                
                                    <input :id="record.id" type='checkbox' v-model="selected_reports" :value="record">
                                    
                                <label :for="record.id">
                                <div :class="$style.report_code"> {{record.code}} </div>
                                    {{objLabel(record,'name')}}
                                </label>
                            </td><td style="width:15%">
                                <label :class="$style.main_label">                                    
                                    {{record.retentionPeriod}}
                                </label>
                            </td>
                            
                        </tr>
                    </table>
                    </div>        
                    <br>
                    
                    <transition name='fade'>
            <button v-if="newRetentionPolicy&&selected_reports.length" @click="updateReport" class="themed" style="margin-left: 15px; margin-bottom:15px; padding: 5px;">
                <i class="fa fa-save"></i> 
                {{'save'|str}}
            </button>
            </transition>      
                </fieldset>
          </div>
       
    </div>
</div>
</template>

<script>
export default {
    name: 'retentionManagement',
    props: {
        adminData: {
            type: Object,
            required: true
        }
    },
    data: function(){
        return {
            selected_reports: [],
            newRetentionPolicy: null,
            report_search: null,
            filtered_reports: [],
            checked:false

        }
    },
    methods:{        
        init: function(){
            this.filterReports();            
        },
        toggle_check_all: function(){
            if(this.checked===false){
                this.selected_reports=[];
            }
            else{
                this.selected_reports=[];
                for(let i=0; i<this.list_reports.length; i++){
                    this.selected_reports.push(this.list_reports[i]);
                }
            }
        },
        updateReport: function(){
            var self = this;
            let selected_reports_for_api = {};
            selected_reports_for_api["newRetentionPolicy"] = this.newRetentionPolicy;
            var temp = []
            for(let i = 0; i<self.selected_reports.length; i++ ){
                temp.push(self.selected_reports[i].id)
                self.selected_reports[i].retentionPeriod = self.newRetentionPolicy;
            }
            
            selected_reports_for_api["selected_report_ids"] = temp;
            console.log(selected_reports_for_api)
            self.$api.updateRetention(selected_reports_for_api).then((response)=>{
                //console.log(response)
                for(let i = 0; i<self.selected_reports.length; i++ ){
                self.selected_reports[i].updated_at = response.updated_datetimes[i]
                }
                self.selected_reports = []
                self.newRetentionPolicy = null
            });
           
        },
        filterReports: function() {
            var self = this;
            clearTimeout(self.timer);
            self.timer = setTimeout(function(){
                
                var list = [];
                if(self.report_search!=null){
                    for(let i=0; i<self.list_reports.length; i++){
                        let report = self.list_reports[i];
                        if(report.name!=null && ((self.objLabel(report, 'name').toLowerCase().includes(self.report_search.toLowerCase()))  || report.retentionPeriod.toString().includes(self.report_search.toLowerCase()) || report.code.toLowerCase().includes(self.report_search.toLowerCase())  )){    
                            list.push(report)
                        }
                    }

                }else{
                    list = self.list_reports;
                }
                self.filtered_reports = list;
                //console.log(self.filtered_reports)
            },100);
        },
        label: function(key){
            return this.$Localization.str(key);
        },
        objLabel: function(obj,key){
            return this.$Localization.objStr(obj,key);
        }
    },
    computed: {
        list_reports: function(){
            return this.adminData.userAdmin.report_metadata;
        },
    },
    mounted: function(){
        this.init();
    },
    watch:{
        report_search: function(){
            this.filterReports();  
        
                  
        }
    }

}
</script>

<style>

</style>

<style module>
.main_label{
    display: inline-block;
    min-width: 110px;
    font-size: 1em;
    font-weight: bold;    
}
.section_label{
    display: inline-block;
    min-width: 110px;
    font-size: 1em;
    font-weight: bold;     
}
.selectAll{
    position: absolute;
    right: 0px;
    top: -8px;
    background-color: #FDFDFD;
    padding-left: 10px;
    margin-left: 10px;
}
.main{
    position: relative;
    display: inline-block;
    vertical-align: top;
    width: 90%;
    min-height: 400px;
    text-align: left;
    padding: 0;
}

.main fieldset{
    position: relative;
    padding: 3px;
    margin: 0;
}

.formItem{
    display: block;
    margin: 10px;
    border-bottom: 1px solid whitesmoke;
    padding-bottom: 3px;
    margin-bottom: 5px;
    font-size: 0.8em;
}

.main table{
    /*list-style: none;
    margin-left: 0px;*/
    display: inline-block;
}

.main tr{
    width:100%;
    vertical-align: middle;
    padding: 0;
}
.main table{
    /*margin-left: -15px;*/
}
.main td{
    /*margin-left: -20px;
    padding-left: 5px;
    border-radius: 2px;*/
    padding:0;
    font-size:0.9em;
    vertical-align:middle;
}
.main td:hover:nth-child(odd){
    text-decoration: underline;
}
    .main tr:nth-child(even){
        background-color: whitesmoke;
        
        
    }
.main td:nth-child(even){
        text-align: center;
        font-size: 0.8em;
        
    }
.main input[type='checkbox']{
    width: 15px;
    height: 15px;
    margin: 5px;
    /*transform: translateY(3px);*/
    vertical-align: middle;
    display: inline-block;
}
.main input[type="text"]{
    font-size:1.2em;
    min-width: 200px;
     vertical-align: middle;
}
.main input[type="number"]{
    font-size:1em;
    min-width: 200px;
}
.grant_access_container{
    width:60%;
    display:inline-block;
    vertical-align:top;
}

@media only screen and (max-width: 1024px) {
    .grant_access_container{
        width:100%;
    }
}
.main button{
    display: inline-block;
}
.checkbox_container{
    height:300px;
    max-width: 590px;
    border: 1px solid whitesmoke; 
    border-radius: 5px;
    overflow-y: scroll;    
}
.main th{
    /*position: sticky;
    z-index:0;
    top:0;
    background: white;*/
}
.report_code{
    font-size: 0.75em;
    font-weight: normal;
    color: #a71414;
    display: inline-block;
}

</style>